<template>
  <div
    class="bg-primary container-fluid h-100 d-flex align-items-center justify-content-center"
    style="min-height: calc(100vh - 5rem)"
    data-cy="pagamento-boleto-bg-container"
  >
    <negociacao-nao-encontrada-erro
      :show="!negociacao"
      @voltar="cancel()"
      data-cy="pagamento-boleto-negociacao-erro"
    />

    <div
      class="col-md-10 col-lg-10 col-xl-10"
      v-if="negociacao"
      data-cy="pagamento-boleto-main-col"
    >
      <div class="card rounded-0" data-cy="pagamento-boleto-card">
        <div class="card-body p-lg-5" data-cy="pagamento-boleto-card-body">
          <fieldset
            :disabled="loading"
            v-if="!pagamento_finalizado"
            data-cy="pagamento-boleto-fieldset"
          >
            <div
              class="text-center mb-4"
              data-cy="pagamento-boleto-title-container"
            >
              <h4
                class="text-primary font-weight-bold"
                data-cy="pagamento-boleto-title"
              >
                Informações para o Pagamento
              </h4>
            </div>
            <b-form
              @submit.stop.prevent="submeterFormulario($event)"
              class="needs-validation"
              novalidate
              data-cy="pagamento-boleto-form"
            >
              <b-row data-cy="pagamento-boleto-row-valor">
                <b-col
                  md="3"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-boleto-col-valor"
                >
                  <strong data-cy="pagamento-boleto-label-valor">
                    Valor Total
                    <span
                      class="text-success"
                      data-cy="pagamento-boleto-span-valor"
                    >
                      {{ (negociacao && negociacao.valor) | currency }}
                    </span>
                  </strong>
                </b-col>
              </b-row>

              <b-row data-cy="pagamento-boleto-row-nome">
                <b-col
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-boleto-col-nome"
                >
                  <label
                    for="nomeCartao"
                    v-required
                    data-cy="pagamento-boleto-label-nome"
                  >
                    Nome
                  </label>
                  <b-form-input
                    class="form-control text-uppercase"
                    type="text"
                    ref="nomeCartao"
                    v-model="form.nome"
                    :state="validation.nome"
                    id="nomeCartao"
                    required
                    maxlength="30"
                    trim
                    autocomplete="off"
                    placeholder="Nome"
                    data-cy="pagamento-boleto-input-nome"
                  />
                </b-col>
              </b-row>

              <dados-e-contato
                :form="form"
                :validation="validation"
                data-cy="pagamento-boleto-dados-contato"
              ></dados-e-contato>

              <hr class="mt-3 mb-2" data-cy="pagamento-boleto-hr-endereco" />

              <endereco
                :form="form"
                :validation="validation"
                data-cy="pagamento-boleto-endereco"
              ></endereco>

              <div
                class="w-100 d-flex justify-content-between mt-2"
                data-cy="pagamento-boleto-btn-row"
              >
                <b-button
                  variant="white"
                  class="btn-outline-primary rounded-0"
                  @click="cancel()"
                  data-cy="pagamento-boleto-btn-cancelar"
                >
                  <strong data-cy="pagamento-boleto-btn-cancelar-label">
                    <font-awesome-icon
                      :icon="['fas', 'times']"
                      data-cy="pagamento-boleto-btn-cancelar-icon"
                    ></font-awesome-icon>
                    Cancelar
                  </strong>
                </b-button>
                <b-button
                  variant="primary"
                  class="rounded-0"
                  type="submit"
                  data-cy="pagamento-boleto-btn-finalizar"
                >
                  <strong data-cy="pagamento-boleto-btn-finalizar-label">
                    <font-awesome-icon
                      v-if="loading"
                      class="fa-spin"
                      :icon="['fa', 'circle-notch']"
                      data-cy="pagamento-boleto-btn-finalizar-icon-loading"
                    ></font-awesome-icon>

                    <font-awesome-icon
                      v-if="!loading"
                      :icon="['fas', 'money-check-alt']"
                      data-cy="pagamento-boleto-btn-finalizar-icon"
                    ></font-awesome-icon>
                    <span
                      v-if="!loading"
                      data-cy="pagamento-boleto-btn-finalizar-span"
                    >
                      Finalizar pagamento
                    </span>
                    <span
                      v-if="loading"
                      data-cy="pagamento-boleto-btn-finalizar-span-loading"
                    >
                      Processando pagamento
                    </span>
                  </strong>
                </b-button>
              </div>
            </b-form>
          </fieldset>
          <div
            class="m-5 text-center"
            v-if="pagamento_finalizado"
            data-cy="pagamento-boleto-finalizado-container"
          >
            <font-awesome-icon
              size="10x"
              class="text-success"
              :icon="['far', 'check-circle']"
              data-cy="pagamento-boleto-finalizado-icon"
            ></font-awesome-icon>

            <div
              class="col-6 offset-3"
              data-cy="pagamento-boleto-finalizado-col"
            >
              <router-link
                :to="{
                  name: 'index',
                  params: { organizationId: $route.params.organizationId }
                }"
                class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
                data-cy="pagamento-boleto-finalizado-link"
              >
                Boleto gerado com sucesso!
              </router-link>
              <div data-cy="pagamento-boleto-finalizado-download">
                Caso o download não tenha iniciado automaticamente,
                <b-link
                  target="_blank"
                  @click="abrirBoleto()"
                  data-cy="pagamento-boleto-finalizado-download-link"
                >
                  clique aqui
                </b-link>
                para baixar o boleto
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validCPF, validEmail } from "@/core/enumHelper";
import { mapGetters } from "vuex";

import { axiosInstance as Axios } from "@/main";
import DadosEContato from "./dadosEContato";
import Endereco from "./endereco";
import NegociacaoNaoEncontradaErro from "@/views/negociacaoNaoEncontradaErro";

const requiredFields = {
  nome: null,
  cpf: null,
  email: null,
  telefonePrincipal: null,
  uf: null,
  cep: null,
  rua: null,
  numero: null,
  bairro: null,
  cidade: null
};

export default {
  name: "pagamentoBoleto",
  components: { NegociacaoNaoEncontradaErro, DadosEContato, Endereco },
  data() {
    return {
      negociacao: null,
      loading: false,
      validation: {},
      form: {
        ...requiredFields
      },
      pagamento_finalizado: false,
      url: null
    };
  },
  computed: {
    type() {
      return this.$store.getters.type;
    },
    usuario() {
      return this.$store.getters.user;
    },
    agendamento() {
      return this.$store.getters.get_agendamento;
    },
    ...mapGetters(["get_selected", "token"])
  },
  async mounted() {
    const valor = this.get_selected.find(it => it.stepId === 2).valor;
    this.negociacao = valor ? { valor } : null;

    this.form.nome = this.usuario.nome;
    this.form.cpf =
      this.usuario.tipoDocumento === "CPF"
        ? this.usuario.numeroDocumento
        : null;
    this.form.telefonePrincipal = this.usuario.telefonePrincipal;
    this.form.email = this.usuario.email;

    const payload = {
      name: "finish",
      params: { organizationId: this.$route.params.organizationId },
      query: {
        ...(localStorage.getItem("telemedicina")
          ? { telemedicina: localStorage.getItem("telemedicina") }
          : {})
      }
    };

    await this.$store.dispatch("set_to", payload);
    await this.$store.dispatch("set_from", payload);

    await this.$store.dispatch("set_actual", this.$route.fullPath);

    const agendaId = this.get_selected[3].agendaId;

    const negociacao = await Axios.post(
      `${this.$serverHost}agendamentos/negociacao/${agendaId}`,
      {
        agendaId: this.get_selected[3].agendaId
      },
      {
        headers: {
          "X-Organizacao-ID": this.$route.params.organizationId
        },
        params: {
          convenio_id: this.agendamento.convenio.id,
          especialidade_id: this.agendamento.especialidade.id,
          procedimento_id: this.agendamento.procedimento.id,
          clinica_id: this.agendamento.clinica.id
        }
      }
    );

    this.negociacao = negociacao.data;
  },
  methods: {
    cancel() {
      this.$router.push(this.$store.getters.from);
    },
    validateRequired(form) {
      const validation = {};

      Object.keys(requiredFields).forEach(fieldName => {
        validation[fieldName] = !!form[fieldName];
      });

      return validation;
    },
    validateSpecificRules(form) {
      const validation = {};

      const telefonePrincipal = (form.telefonePrincipal || "").replace(
        /\D/g,
        ""
      );
      const cpf = (form.cpf || "").replace(/\D/g, "");
      const cep = (form.cep || "").replace(/\D/g, "");

      validation.email = validEmail(form.email);
      validation.cpf = validCPF(cpf);

      validation.cep = cep.length === 8;
      validation.telefonePrincipal = telefonePrincipal.length >= 10;

      return validation;
    },
    async submeterFormulario() {
      const form = this.form;

      this.validation = {
        ...this.validateRequired(form),
        ...this.validateSpecificRules(form)
      };

      const fields = Object.entries(this.validation);
      const invalidField = fields.filter(([, valid]) => !valid);

      if (invalidField.length > 0) {
        console.log(invalidField);

        this.$bvToast.toast(
          "Alguns dados informados estão incompletos, por favor corrija-os e tente novamente.",
          {
            title: "Dados incompletos",
            autoHideDelay: 10000,
            variant: "danger"
          }
        );

        return;
      }

      const dadosCartao = {
        valorPago: this.negociacao.valor
      };

      const endereco = {
        uf: form.uf,
        cep: form.cep,
        pais: "Brasil",
        bairro: form.bairro,
        logradouro: form.rua,
        numero: form.numero,
        localidade: form.cidade
      };

      const dadosPessoais = {
        cpfCnpj: form.cpf,
        nome: form.nome,
        email: form.email,
        telefone: form.telefonePrincipal,
        endereco
      };

      this.loading = true;

      try {
        const response = await Axios.post(
          `${this.$serverHost}protected/pagamento/boleto`,
          {},
          {
            headers: {
              "X-Organizacao-ID": this.$route.params.organizationId,
              Authorization: `Bearer ${this.token}`
            },
            params: {},
            data: {
              marcacaoId: this.agendamento.id,
              dadosCartao,
              dadosPessoais
            }
          }
        );

        if (response.status === 200) {
          this.url = response.data;
          this.pagamento_finalizado = true;
          this.abrirBoleto();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    abrirBoleto() {
      window.open(this.url, "_blank");
    },
    clear() {
      this.form = {};
      this.validation = {};
    }
  }
};
</script>

<style scoped></style>
